import { useCallback, useEffect, useState } from "react";
import { useDragLayer } from "react-dnd";

// While an event is dragged, the other events stop catching the pointer so the drop reaches the
// cells under them. The dragged event itself is released one frame later - touching the drag
// source during dragstart can make the browser cancel the drag - so it can still be dropped
// onto the cells it originally covered (e.g. moving a 12am shift to 1am).
export const useDragPassThrough = () => {
    const { isDragActive, draggedId } = useDragLayer((monitor) => ({
        isDragActive: monitor.isDragging(),
        draggedId: (monitor.getItem() as any)?.id,
    }));
    const [sourceReleased, setSourceReleased] = useState(false);

    useEffect(() => {
        if (!isDragActive) {
            setSourceReleased(false);
            return;
        }
        const frame = requestAnimationFrame(() => setSourceReleased(true));
        return () => cancelAnimationFrame(frame);
    }, [isDragActive]);

    return useCallback(
        (eventId: string) => isDragActive && (eventId !== draggedId || sourceReleased),
        [isDragActive, draggedId, sourceReleased],
    );
};
